export const MIN_SCALE = 1;
export const MAX_SCALE = 5;
export const SCALE_STEP = 0.2;

export interface Offset {
  x: number;
  y: number;
}

export const clampScale = (scale: number): number =>
  Math.min(Math.max(scale, MIN_SCALE), MAX_SCALE);

export const stepScale = (currentScale: number, direction: 1 | -1): number =>
  clampScale(currentScale + direction * SCALE_STEP);

// keeps the point under the cursor fixed on screen, point is relative to the image center
export const zoomOffset = (
  offset: Offset,
  currentScale: number,
  newScale: number,
  point: Offset = { x: 0, y: 0 },
): Offset => {
  if (newScale === MIN_SCALE) return { x: 0, y: 0 };
  const scaleRatio = newScale / currentScale;
  return {
    x: point.x - (point.x - offset.x) * scaleRatio,
    y: point.y - (point.y - offset.y) * scaleRatio,
  };
};

// wraps a rotation in degrees into [0, 360), handling negative input too
export const wrapRotation = (degrees: number): number =>
  ((degrees % 360) + 360) % 360;
